export const LS_REDIRECTION_TO = 'redirectAfterLogin';
export const LS_AUTH_KEY = 'at';

export const IS_LOGGED_IN_LOCALSTORAGE = 'isLoggedInLS';
